import {
  ROLE_DATA_REPORTER,
  ROLE_EXECUTIVE_REPORTER,
  ROLE_OWNER,
  ROLE_VALIDATOR,
} from '@app/utils/constants';

export const ROUTES = [
  {
    path: '/activities',
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/reporter/validations',
    roles: [ROLE_EXECUTIVE_REPORTER],
  },
  {
    path: '/reports',
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/reporter',
    roles: [ROLE_EXECUTIVE_REPORTER],
  },
  {
    path: '/corporates/invites',
    roles: [ROLE_OWNER],
  },
  {
    path: '/corporates/send-invite',
    roles: [ROLE_OWNER],
  },
  {
    path: '/corporates/pending',
    roles: [ROLE_OWNER],
  },
  {
    path: '/corporates/approved',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine/units',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine/:categoryId/sources',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine/:categoryId/sources/:sourceId/input-table-fields',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine/:categoryId/sources/:sourceId/input-table-data',
    roles: [ROLE_OWNER],
  },
  {
    path: '/calc-engine/:categoryId/sources/:sourceId/equations',
    roles: [ROLE_OWNER],
  },
  {
    path: '/facilities/:entityId',
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/subsidiaries/:entityId',
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/activities/add',
    roles: [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER],
  },
  {
    path: '/validators/invites',
    roles: [ROLE_OWNER],
  },
  {
    path: '/validators/send-invite',
    roles: [ROLE_OWNER],
  },
  {
    path: '/validators/reports',
    roles: [ROLE_VALIDATOR],
  },
  {
    path: '/validators/reports/review/:reportId',
    roles: [ROLE_VALIDATOR],
  },
  {
    path: '/',
    roles: [
      ROLE_EXECUTIVE_REPORTER,
      ROLE_OWNER,
      ROLE_DATA_REPORTER,
      ROLE_VALIDATOR,
    ],
  },
];
